var _defs, _use, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crm-customer_svg__a",
    d: "M12.8 12.7v-1.4c0-.3.3-.6.6-.6s.6.3.6.6v1.4h1.4c.3 0 .6.3.6.6s-.3.6-.6.6H14v1.4c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-1.4h-1.4c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h1.4zM9.1 7.9c1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2zm-5.3 6.7h7.6c.3 0 .6.3.6.6s-.3.6-.6.6H3.2c-.3 0-.6-.3-.6-.6v-.6c.2-2.9 2-5.4 4.3-6.3-.7-.7-1.1-1.6-1.1-2.7 0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4c0 1.1-.5 2-1.3 2.6.8.3 1.6.8 2.3 1.5.1.1.1.2 0 .2h-1.1-.2c-.2.2-.2.1-.3.1-.9-.6-1.8-1-2.9-1-2.7 0-5 2.4-5.3 5.6z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-customer_svg__a",
    overflow: "visible"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "crm-customer_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-customer_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crm-customer_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crm-customer_svg__c",
    d: "M-561.9-725h1424v1785h-1424z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-customer_svg__c",
    overflow: "visible"
  }))));
}

export default SvgCrmCustomer;